import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api'; // ⬅️ Make sure this points to your axios setup

const TipListContext = createContext();

export function TipListProvider({ children }) {
  const [tipMap, setTipMap] = useState({});

  // Load from localStorage on init
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('barterfi_tips')) || {};
    setTipMap(stored);
  }, []);

  // Save to localStorage when updated
  useEffect(() => {
    localStorage.setItem('barterfi_tips', JSON.stringify(tipMap));
  }, [tipMap]);

  // ✅ Return tips from cache or empty array
  const getTipsForPost = (postId) => tipMap[postId] || [];

  // ✅ Add a new tip to a post
  const addTipToPost = (postId, newTip) => {
    setTipMap((prev) => ({
      ...prev,
      [postId]: [...(prev[postId] || []), newTip],
    }));
  };

  // ✅ Fetch from backend (used in Post.js)
  const fetchTipsForPost = async (postId) => {
    try {
      const res = await api.get(`/tips/post/${postId}`);
      const tips = res.data.tips || [];
      setTipMap((prev) => ({ ...prev, [postId]: tips }));
      return tips;
    } catch (err) {
      console.error('❌ Failed to fetch tips from server:', err);
      return [];
    }
  };

  return (
    <TipListContext.Provider value={{ getTipsForPost, addTipToPost, fetchTipsForPost }}>
      {children}
    </TipListContext.Provider>
  );
}

export function useTipList() {
  return useContext(TipListContext);
}
